module.exports = __webpack_public_path__ + "static/img/12.3078f793.jpg";